/*
 * @Description:
 * @Date: 2021-10-20 11:43:02
 */
export const route = [
  {
    path: '/task-progress/list',
    name: 'task-process-list',
    meta: {
      title: '任务进度'
    },
    component: () => import('../views/task-process-list.vue')
  }
];
